import { MainView } from "../../views/login";

export default function Component(props) {
    return (
        <>
            <MainView />
        </>
    );
}